<template>
  <div class="header-w">

    <div class="div_1 d_flex justify_content_sb align_item_fe" :style="{'background':`url(${oss_pub_domain}site/article/cover/khslUjcgr0BD4wTh.png) center 100%  no-repeat`}">
      <DateTime />
      <div class="title">{{ siteName }}大数据</div>

      <!-- 仅作占位 -->
      <div />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DateTime from './DateTime.vue'
import request from '@/utils/request'
export default {
  components: {
    DateTime
  },
  computed: {
    ...mapGetters(['siteName', 'oss_pub_domain'])
  },
  created() {

    // request({
    //   url: 'http://wthrcdn.etouch.cn/weather_mini?city=广州'
    // }).then(res => {
    //   // console.log(res)
    // })
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.header-w {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 95px;
  padding: 0 50px;
  .title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 3px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 0%, #9BB5FF 100%);
    /*必需加前缀 -webkit- 才支持这个text值 */
    -webkit-background-clip: text;
    /*text-fill-color会覆盖color所定义的字体颜色： */
    -webkit-text-fill-color: transparent;
    transform: translateX(-140px);
  }
  .div_1{
    width: 100%;
    height: 50px;
    padding: 0 0 8px 0;
  }
}
</style>
